import affiliate from './it/affiliate'
import bankTransfer from './it/bankTransfer'
import cart from './it/cart'
import cartAndWarehouse from './it/cartAndWarehouse'
import common from './it/common'
import consult from './it/consult'
import debt from './it/debt'
import distribution from './it/distribution'
import estimation from './it/estimation'
import form from './it/form'
import home from './it/home'
import kol from './it/kol'
import order from './it/order'
import orderDetail from './it/orderDetail'
import packages from './it/package'
import pay from './it/pay'
import pecenter from './it/pecenter'
import points from './it/points'
import previewPackage from './it/previewPackage.json'
import previewPackageOptimize from './it/previewPackageOptimize'
import product from './it/product'
import returnChange from './it/returnChange'
import search from './it/search'
import shareCoupon from './it/shareCoupon'
import sharePackage from './it/sharePackage'
import shoppingGuide from './it/shoppingGuide'
import site from './it/site'
import status from './it/status'
import storage from './it/storage'
import tag from './it/tag'
import tips from './it/tips'
import transport from './it/transport'
import uniOrder from './it/uniOrder'
import vip from './it/vip'
import warnTips from './it/warnTips'
export default {
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  uniOrder,
  bankTransfer,
  distribution,
  site,
  consult,
  transport,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  kol,
  vip,
}
